// extracted by mini-css-extract-plugin
export var sbShowMain = "inlineImage-module--sb-show-main--3L6NL";
export var wrapper = "inlineImage-module--wrapper--2uESy";
export var alignLeft = "inlineImage-module--alignLeft--3ojNp";
export var alignRight = "inlineImage-module--alignRight--3TdcF";